import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../../../../../domain/entities/ExceptionEntity";
import ShiftEntity from "../../../../../domain/entities/ShiftEntity";

const GetShiftCalendarApiImpl = (shiftId: string, startDate: Date, endDate: Date): Promise<Either<ExceptionEntity, ShiftEntity[]>> => {
    throw new Error('Method not implemented.');
}

export default GetShiftCalendarApiImpl;